import { Dropdown, DropdownItem } from "shared/components/bulma/dropdown";

const SelectMonth = ({ onChange, month, months }) => {
    if (!month) { return null; }

    return (
        <Dropdown id={month} activeOption={month} className="is-fullwidth" >
            {months.map((option) => (
                <DropdownItem key={option} onClick={() => onChange(option)}>
                    {option}
                </DropdownItem>
            ))}
        </Dropdown >
    )
}

export default SelectMonth;
